module.exports = __webpack_public_path__ + "static/img/uniqueBg2.3aa1a26c.png";